/**
 * The typical error format returned by NestJS.
 */
export interface NestJsErrorResponse {
  statusCode: number;
  message: string | string[];
  error: string;
}

/**
 * Internal error class for API calls.
 * This is an implementation detail of apiClient.ts and toAppError.ts.
 * It must not cross layer boundaries — use NormalizedError at all boundaries instead.
 */
export class ApiError extends Error {
  public status: number;
  public body: NestJsErrorResponse | string | null;

  constructor(status: number, message: string, body: NestJsErrorResponse | string | null) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
    Object.setPrototypeOf(this, ApiError.prototype);
  }

  /**
   * @deprecated Only used inside toAppError(). Access validationMessages on NormalizedError instead.
   */
  errors() {
    const messages = (this.body as NestJsErrorResponse)?.message;
    if (Array.isArray(messages)) {
      return messages;
    } else {
      return [messages];
    }
  }
}
